import {
  optionalInit,
  fbInit,
  initTwitterPixel,
  initRollbar,
  nonceInit,
} from 'client/shared/integrations';

export function integrationsInit() {
  optionalInit(fbInit, 'facebookAppId');
  initTwitterPixel();
  optionalInit(initRollbar, 'rollbarClientToken');
  nonceInit();
}
